function validateCountry(iso2Code, countryConfig) {
  const isCountryIncluded = countryConfig?.iso2CodeList?.includes(iso2Code);
  return countryConfig?.mode === "include" ? isCountryIncluded : !isCountryIncluded;
}
export {
  validateCountry
};
//# sourceMappingURL=utils.js.map
